import styled from 'styled-components'

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const CardContainer = styled.div`
  border-radius: ${props => props.theme.primitives.radius.radius3};
  display: flex;
  flex-direction: column;
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16}`};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius3};
`

export const CardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const CardHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const CardBody = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16}`};
`

export const CardBodyColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  align-items: ${props => props.alignItems};
`

export const TableContainer = styled.div`
  position: relative;
  overflow-x: scroll;
  padding-bottom: ${props => props.theme.spacing.sp32};
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`

export const TableHeader = styled.thead`
  text-align: left;
  white-space: nowrap;
`

export const TableHeaderCell = styled.th`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
`

export const TableBody = styled.tbody`
  tr:nth-child(odd) {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`

export const TableCell = styled.td`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
  white-space: nowrap;
`
